import React from "react";

type Props = {
  closeToast?: () => {};
};

export default function NotificationCloseButton(props: Props) {
  return <i className="fas fa-times" onClick={props.closeToast} />;
}
